/**
 * Não usado em main.tsx: o painel hidrata com GET /api/admin/catalog. Pode reativar installAdminLocalStorageAutoSync
 * se quiser POST /api/admin/sync debounced a cada alteração no localStorage.
 */
import { pushAdminSyncToApiDeferred } from './adminSyncApi';

const DEBOUNCE_MS = 2800;

function shouldTriggerSyncForKey(key: string): boolean {
  if (key === 'authUserAdmin') return false;
  return (
    key.startsWith('naviex-') ||
    key.startsWith('navi_admin') ||
    key === 'guiaRegisteredUsers'
  );
}

let debounceTimer: ReturnType<typeof setTimeout> | null = null;
let patched = false;

function scheduleDebouncedSync(): void {
  if (debounceTimer != null) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    debounceTimer = null;
    pushAdminSyncToApiDeferred();
  }, DEBOUNCE_MS);
}

/**
 * Após cada `localStorage.setItem` / `removeItem` em chaves de dados do admin, agenda envio do snapshot à API
 * (`VITE_ADMIN_SYNC_URL` ou proxy). Desative com `VITE_ADMIN_AUTO_SYNC=false`.
 */
export function installAdminLocalStorageAutoSync(): void {
  if (patched || typeof window === 'undefined') return;
  const flag = import.meta.env.VITE_ADMIN_AUTO_SYNC;
  if (flag === 'false' || flag === '0') return;

  patched = true;
  const proto = Storage.prototype;
  const origSet = proto.setItem;
  const origRemove = proto.removeItem;

  proto.setItem = function setItemPatched(key: string, value: string) {
    origSet.call(this, key, value);
    if (shouldTriggerSyncForKey(key)) scheduleDebouncedSync();
  };

  proto.removeItem = function removeItemPatched(key: string) {
    origRemove.call(this, key);
    if (shouldTriggerSyncForKey(key)) scheduleDebouncedSync();
  };
}
